"use client";

import CardGrid from "@/components/card-grid/card-grid";
import FilterBar from "@/components/filter-bar/filter-bar";
import { getMechanismContent } from "@/lib/api/mechanisms/content-grid";
import { BProgress } from "@bprogress/core";
import Image from "next/image";
import { useEffect, useState } from "react";
import useSWR from "swr";
import Loading from "../_partials/loading/loading";

const MechanismInfo = ({
	mechanism,
	sorts,
	initialContents,
	initialPage,
	initialSearchTerm,
	initialGenre,
	initialSort,
	kind,
}: {
	mechanism: any;
	sorts: any[];
	initialContents: any;
	initialSearchTerm?: any;
	initialGenre?: any;
	initialSort?: any;
	initialPage?: string;
	kind: any;
}) => {
	const [selectedGenre, setSelectedGenre] = useState(initialGenre ?? undefined);
	const [searchTerm, setSearchTerm] = useState(initialSearchTerm || "");
	const [page, setPage] = useState(initialPage ?? "1");
	const [selectedSort, setSelectedSort] = useState(initialSort ?? undefined);

	const {
		data: contents,
		mutate,
		isLoading,
	} = useSWR(
		[
			"mechanism-content",
			mechanism?.id,
			searchTerm,
			selectedSort?.value,
			selectedGenre?.id,
			page,
		],
		() =>
			getMechanismContent(
				kind.kind,
				mechanism?.id,
				searchTerm,
				selectedGenre?.id,
				selectedSort,
				page,
			),
		{ fallbackData: initialContents, revalidateOnMount: false },
	);

	useEffect(() => {
		const query = new URLSearchParams();
		searchTerm && query.append("title", searchTerm);
		page && query.append("page", page);
		selectedGenre && query.append("genres", selectedGenre.id);
		if (selectedSort) {
			query.append("sortBy", selectedSort.sortBy);
			query.append("direction", selectedSort.direction);
		}

		const qs = query.toString();
		const newUrl = qs
			? `${window.location.pathname}?${qs}`
			: window.location.pathname;

		window.history.replaceState(null, "", newUrl);

		mutate();
	}, [searchTerm, selectedSort, selectedGenre, page, mutate]);

	useEffect(() => {
		if (isLoading) {
			BProgress.start();
		} else {
			BProgress.done();
		}
	}, [isLoading]);

	return (
		<>
			<div className="w-full text-white py-6 px-6 lg:px-[80px] flex flex-col items-start">
				<div className="w-full py-6 rounded-lg shadow-lg flex flex-col justify-between lg:flex-row gap-4">
					<div className="lg:w-2/3 py-6 flex flex-col gap-4">
						<h1
							className="text-[35px] md:text-[48px] font-extraBold text-right"
							dir="ltr"
						>
							{mechanism?.persianTitle ?? mechanism?.title}
						</h1>
					</div>
					<div className="w-full lg:w-[376px] flex justify-center flex-col items-center">
						<div className={"w-full lg:w-[376px]"}>
							{mechanism?.logo?.code ? (
								<Image
									src={process.env.NEXT_PUBLIC_FILE_URL + mechanism?.logo?.code}
									alt={mechanism?.name}
									width={376}
									height={526}
									layout="responsive"
									className={"rounded-lg max-w-[376px] m-auto min-w-[376px]"}
								/>
							) : null}
						</div>
					</div>
				</div>
				<div className="w-full flex flex-wrap justify-between items-center py-8 gap-4">
					<h2 className="text-white text-[32px] font-bold">آثار</h2>
					<FilterBar
						showSearch={true}
						showSort={true}
						showGenre={false}
						searchTerm={searchTerm}
						setSearchTerm={setSearchTerm}
						initialSorts={sorts}
						setSort={setSelectedSort}
						setGenre={setSelectedGenre}
					/>
				</div>
				{isLoading ? (
					<div className="w-full h-full min-h-screen flex justify-center items-center">
						<Loading />
					</div>
				) : (
					<CardGrid
						data={contents}
						kind={kind.kind}
						page={page}
						setPage={setPage}
					/>
				)}
			</div>
		</>
	);
};

export default MechanismInfo;
